import { InventoryOperation } from "../apis/armoryApi";
import AssetHistoryPanel from "./AssetHistoryPanel";
import NotesPanel from "./NotesPanel";
import AssetPaymentsPanel from "./AssetPaymentsPanel";
import { useEffect, useState } from "react";
import { useArmoryApi } from "../hooks/useArmoryApi";
import { TabPanel, TabView } from "primereact/tabview";

interface LesseeAssetHistoryComponentProps {
  inventoryOperations: InventoryOperation[];
}

const LesseeAssetHistoryComponent: React.FC<LesseeAssetHistoryComponentProps> = ({
  inventoryOperations,
}) => {
  const [assetsHistory, setAssetsHistory] = useState<{ [key: number]: InventoryOperation[] }>({});
  const { getAssetHistory } = useArmoryApi();
  const lesseeAssetHistory = inventoryOperations
    .filter((operation) => operation.success && operation.inventoryObject)
    .reverse();

  const getCurrentAssetHistory = async () => {
	  if (!lesseeAssetHistory) {
		return;
	  }

	  for (const item of lesseeAssetHistory) {
		if (item.inventoryObjectId){			
			const apiResponse = await getAssetHistory(item.inventoryObjectId);

			if (apiResponse.data) {
			  setAssetsHistory(prev => ({
				...prev,
				[item.id]: apiResponse.data as InventoryOperation[] 
			  }));
			}
		}
	  }
  };

  useEffect(() => {
	getCurrentAssetHistory()
  }, [])

  return (
	<div>
		{lesseeAssetHistory.map((item: any) => (
		<div 
			key={item.id}
			style={{ 
			  padding: "1rem 0",
			  borderBottom: "1px solid #ddd"
			}}
		>
			<strong>
			  {item.inventoryObject.assetSku?.type
				? item.inventoryObject.assetSku.type + " - "
				: ""}
			  {item.inventoryObject.serial}
			</strong>
			<div>
				{item.action.name ? item.action.name + " " : ""}
				{new Date(item.date).toLocaleString()}
			</div>
			<div style={{ flex: 1, minWidth: 0, overflowX: "auto", maxWidth: "100%" }}>
				<TabView>
					<TabPanel header="History">
						<AssetHistoryPanel
						inventoryOperations={assetsHistory[item.id] ?? []}
						/>
					</TabPanel>
					<TabPanel header="Notes">
						<NotesPanel
						inventoryObjectId={item.inventoryObjectId}
						/>
					</TabPanel>
					<TabPanel header="Payments">
						<div style={{ overflowX: "auto", maxWidth: "100%" }}>
							<AssetPaymentsPanel
							assetId={item.inventoryObjectId}
							/>
						</div>
					</TabPanel>
				</TabView>
			</div>
		</div>
		))}
	</div>
  );
};

export default LesseeAssetHistoryComponent;